import { Row, Col, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import useMonitorAPIService from '../../../services/monitorapiservice';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PieChart, Series, Connector, Legend, Animation, Label, Font } from 'devextreme-react/pie-chart';
import { Switch } from "devextreme-react";
function CampaignDetail(props) {

    const { t } = useTranslation();
    const { getCampaignStatus, changeCampaignStatus } = useMonitorAPIService();
    const [situations, setSituations] = useState([]);

    useEffect(() => {

        if (props.show) {
            getCampaignStatus(props.token, props.campaign.id, res => {
                setSituations(Object.values(res.data));
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.show]);

    function customizeText(arg) {
        return `${arg.valueText} (${arg.percentText}) ${t(arg.argumentText)}`;
    }

    const changeCampStatus = (e) => {
        changeCampaignStatus(props.token, props.campaign.id, e => {

        });

    };
    return (
        <Modal show={props.show} onHide={props.toggleModal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title><FontAwesomeIcon icon={duotone("address-book")} /> {t("campaignstatus")} - {props.campaign.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <Row>
                    <Col > <span className="fs-5 fw-bold text-gray-800 ">{t("status")}  <Switch width={100} switchedOnText={t("enabled")} switchedOffText={t("disabled")} defaultValue={props.campaign.active} onValueChange={changeCampStatus} text /> </span></Col>
                </Row>
                <Row>
                    <Col>
                        <PieChart
                            key={"campaignsdetail"}
                            id="campaignsdetail"
                            dataSource={situations}
                            type="doughnut"
                            resolveLabelOverlapping="shift"
                            rtlEnabled={props.rtl}
                        >
                            <Series
                                argumentField="name"
                                valueField="occurrences"
                            >
                                <Font size={16} />
                                <Label
                                    visible={true}
                                    customizeText={customizeText}
                                >
                                    <Connector visible={true} width={1} />
                                </Label>
                            </Series>
                            <Legend visible={false}
                            ></Legend>
                            <Animation enabled={true}></Animation>
                        </PieChart>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, {})(CampaignDetail);